var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"active-class":"primary white--text","link":"","to":"/task-manager"}},[_c('v-list-item-icon',{staticClass:"mr-4"},[_c('v-icon',[_vm._v("portrait")])],1),_c('v-list-item-title',[_vm._v("Giao nhận công việc")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }